import { captureException } from "@sentry/browser";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IPlan } from "../../../../common/types";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { BrowseActionTypes } from "../models/browseActions";

import {
    GET_RESULTS_REQUEST,
    GET_RESULTS_SUCCESS,
    GET_RESULTS_FAILURE,
} from "../types";

export default () => async (dispatch: Dispatch<BrowseActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({ type: GET_RESULTS_REQUEST });
    const { filters, page, limit: itemsPerPage, sorting: sortType, search } = getState().browse;
    try {
        let now = Date.now();
        const result = await api.post<{
            plans: IPlan[],
            totalPages: number,
            limit: number,
            totalDocs: number,
        }>("get-public-plans", {
            filters: [...filters, ...(!!search ? [{ name: "search", value: search }] : [])],
            page,
            itemsPerPage,
            sortType
        });
        let timeTaken = Math.round((Date.now() - now) / 10) / 100;
        const { plans, totalPages, totalDocs } = result.data;
        dispatch({
            type: GET_RESULTS_SUCCESS,
            payload: {
                plans,
                totalPages,
                totalDocs,
                timeTaken,
            },
        });
    } catch (error) {
        dispatch({
            type: GET_RESULTS_FAILURE,
        })
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};